import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

const SortableParamItem = ({ id, children }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  // Pass listeners down to the first child as handle
  const child = React.Children.only(children);
  const handle = React.cloneElement(child.props.children[0], { ...listeners });

  return (
    <div ref={setNodeRef} style={style} {...attributes}>
      {React.cloneElement(child, {}, [handle, ...React.Children.toArray(child.props.children).slice(1)].map((c, i) => React.cloneElement(c, { key: i })))}
    </div>
  );
};

export default SortableParamItem;